import { FC } from 'react'
import { Ref } from 'react-hook-form'
import { Alert } from '@cmsgov/design-system'
import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'

type ErrorEntry = {
  field: string
  message: string
  ref?: Ref | undefined
}

export type ClaimsFiltersAlertProps = {
  errors?: ErrorEntry[]
}

export const ClaimsFiltersAlert: FC<ClaimsFiltersAlertProps> = ({ errors }) => {
  const { t } = useTranslation('claimsSearch')

  const labelMap: { [field: string]: string } = {
    claimType: t('filterClaimTypeHeading'),
    claimNumber: t('filterClaimNumberHeader'),
    customDateRange: t('filterClaimDateRange.label'),
    start: t('filterClaimDateRange.labelFrom'),
    end: t('filterClaimDateRange.labelTo')
  }

  const focusField = (ref: Ref | undefined) => ref?.focus?.()

  return (
    <Alert hideIcon variation="error" heading={t('filterErrorHeading', { count: errors?.length })}>
      <ul>
        {errors?.map((error, index) => (
          <li key={index}>
            <Button href="#" onClick={() => focusField(error.ref)}>{labelMap[error.field]}</Button>
            <span>{`: ${error.message}`}</span>
          </li>
        ))}
      </ul>
    </Alert>
  )
}
